import React, {Component} from 'react';
import {Card, CardContent, CircularProgress, Grid, Typography} from "material-ui";
import {withStyles} from 'material-ui/styles';
import {connect} from 'react-redux';
import GuidesActions from "../../actions/guides.action";
import {GuidesReducer} from "../../reducers/guides.reducer";
import moment from "moment";
import ReactMarkdown from 'react-markdown';
import BtnIcon from "../../shared/BtnIcon/BtnIcon";
import {Link} from "react-router-dom";
import ReactGA from 'react-ga';

const styles = theme => ({

    card: {
        marginBottom: 16
    },

    subTitle: {
        marginBottom: 16,
        fontSize: 14,
        color: theme.palette.text.secondary,
    },

    guideContent: {
        height: 60
    }
});

class Guide extends Component {

    state = {
        fetchGuides: true
    };

    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);

        GuidesActions.fetchGuides().on('value', data => {
            let dataObj = data.val();
            let finalArr = [];
            if (data.val()) {
                Object.keys(data.val()).map(o => {
                    let object = dataObj[o];
                    object['id'] = o;
                    finalArr.push(object);
                });
            }
            finalArr.reverse();
            this.props.dispatch(GuidesReducer.set(finalArr));
            this.setState({fetchGuides: false});
        }, err => {
            this.setState({fetchGuides: false});
        })
    }

    render() {
        return (
            <div>
                <Grid container>
                    <Grid item md={12}>
                        <div className="base-mbottom">
                            <Link to="/guides">
                                <BtnIcon icon="arrow_back">Retour à l'accueil</BtnIcon>
                            </Link>
                        </div>
                        {this.state.fetchGuides &&
                        <div style={{textAlign: 'center'}}>
                            <CircularProgress/>
                        </div>
                        }
                        {!this.state.fetchGuides && this.renderGuide()}
                    </Grid>
                </Grid>
            </div>
        )
    }

    renderGuide = () => {
        const {guides, match, classes} = this.props;
        const guide = guides.find(g => g.id === match.params.guideId);

        return (
            <Card className={classes.card}>
                <CardContent>
                    <Typography variant="headline" component="h2">
                        {guide.title}
                    </Typography>
                    <Typography className={classes.subTitle}>
                        {moment(guide.created_at).format('dddd DD MMMM YYYY, h:mm')}
                    </Typography>
                    <ReactMarkdown
                        source={guide.content}
                    />
                </CardContent>
            </Card>
        )
    }
}

const state2props = state => ({
    guides: state.Guides.guides
});

export default withStyles(styles)(connect(state2props)(Guide));


// WEBPACK FOOTER //
// ./src/pages/guide/Guide.js